import BAGraficoRelatorio from "entity/Indicador/BA/components/BAGraficoRelatorio"
import BioGraficoRelatorio from "entity/Indicador/Bio/components/BioGraficoRelatorio"
import CMGraficoRelatorio from "entity/Indicador/CM/components/CMGraficoRelatorio"
import MMGraficoRelatorio from "entity/Indicador/MM/components/MMGraficoRelatorio"
import PerfGraficoRelatorio from "entity/Indicador/Perf/components/PerfGraficoRelatorio"
import TMMGraficoRelatorio from "entity/Indicador/TMM/components/TMMGraficoRelatorio"
import TMTGraficoRelatorio from "entity/Indicador/TMT/components/TMTGraficoRelatorio"
import TTCGraficoRelatorio from "entity/Indicador/TTC/components/TTCGraficoRelatorio"
import GraficoPadraoRelatorio from "entity/Indicador/components/GraficoPadraoRelatorio"

export default function GraficosRelatorio(h, mediaAgrupadorList, meta, titulo, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim, primeiro, field) {
    switch (field) {
        case 'bio':
            return BioGraficoRelatorio(h, mediaAgrupadorList, meta, titulo, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim, primeiro)
        case 'cm':
            return CMGraficoRelatorio(h, mediaAgrupadorList, meta, titulo, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim, primeiro)
        case 'mudaMecanizada':
            return MMGraficoRelatorio(h, mediaAgrupadorList, meta, titulo, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim, primeiro)
        case 'perf':
            return PerfGraficoRelatorio(h, mediaAgrupadorList, meta, titulo, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim, primeiro)
        case 'tmm':
            return TMMGraficoRelatorio(h, mediaAgrupadorList, meta, titulo, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim, primeiro)
        case 'tmt':
            return TMTGraficoRelatorio(h, mediaAgrupadorList, meta, titulo, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim, primeiro)
        case 'ttc':
            return TTCGraficoRelatorio(h, mediaAgrupadorList, meta, titulo, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim, primeiro)
        case 'ba':
            return BAGraficoRelatorio(h, mediaAgrupadorList, meta, titulo, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim, primeiro)
        default:
            return GraficoPadraoRelatorio(h, mediaAgrupadorList, meta, titulo, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim, primeiro)
    }
}